import axios from 'axios'
import store from '@/store/index.js'
import router from '@/router'
import { BaseUrl } from '@/utils/config'
import { connectionPayload, safeAccessMessage } from '@/utils/mcpAccess'

// 既有 http.js 固定 POST，并记录原始 Axios 错误；密钥接口独立处理 GET 和错误脱敏。
const client = axios.create({ baseURL: BaseUrl, timeout: 20000 })
const request = async (action, method = 'GET', data) => {
  let response
  try {
    response = await client.request({
      url: `/api/admin/v1/mcpAccess/${action}`, method,
      headers: { Authorization: store.getters['basic/get_token'] || '', 'Content-Type': 'application/json' },
      ...(method === 'GET' ? { params: data } : { data })
    })
  } catch (error) {
    // 不向组件或控制台传递含请求头/响应原文的 AxiosError。
    if (error?.response?.status === 401) {
      router.push({ path: '/login' })
      throw new Error('登录已失效，请重新登录')
    }
    throw new Error(error?.response?.status === 403 ? '无权访问，请确认当前账号状态' : '网络请求失败，请稍后重试')
  }
  const result = response?.data
  if ([10001, -10001].includes(result?.code)) {
    router.push({ path: '/login' })
    throw new Error('登录已失效，请重新登录')
  }
  if (result?.code !== 0) throw new Error(safeAccessMessage(result?.msg) || '请求失败，请稍后重试')
  return result.data
}

export default {
  settings: () => request('settings'),
  setEnabled: enabled => request('setEnabled', 'POST', { enabled: enabled === true }),
  setConnectionEnabled: (connectionId, enabled) => request('setConnectionEnabled', 'POST', { connection_id: connectionId, enabled: enabled === true }),
  createConnection: data => request('createConnection', 'POST', connectionPayload(data)),
  revokeConnection: connectionId => request('revokeConnection', 'POST', { connection_id: connectionId }),
  logs: data => request('logs', 'GET', data)
}
